import { useCallback, useEffect, useState } from 'react';

const useRandomPassword = () => {
    const [password, setPassword] = useState('');

    const generateRandomPassword = useCallback(() => {
        let password = '';
        let numbers = '0123456789';
        let letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let chars = letters.concat(numbers);

        for (let i = 0; i < config.passwordLength; i++) {
            password += chars[Math.floor(Math.random() * chars.length)];
        }

        if (!password.match(/\d/)) {
            const positions = Array.from({ length: config.passwordLength }, (_, i) => i);
            const randomPosition = positions[Math.floor(Math.random() * positions.length)];
            password = password.split('');
            password[randomPosition] = numbers[Math.floor(Math.random() * numbers.length)];
            password = password.join('');
        }
        setPassword(password);
    }, []);

    useEffect(() => {
        generateRandomPassword();
    }, []);

    return {
        password,
        generateRandomPassword,
    };
};

export default useRandomPassword;
